/* tslint:disable */
/* eslint-disable */
/* @relayHash 4e9057ff2bbac299d500cfdbd479a3a2 */

import { ConcreteRequest } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type PromoteMemberInput = {
    userID: string;
    siteIDs: Array<string>;
    clientMutationId: string;
};
export type PromoteMemberMutationVariables = {
    input: PromoteMemberInput;
};
export type PromoteMemberMutationResponse = {
    readonly promoteMember: {
        readonly user: {
            readonly id: string;
            readonly role: USER_ROLE;
            readonly membershipScopes: {
                readonly sites: ReadonlyArray<{
                    readonly id: string;
                    readonly name: string;
                }> | null;
            } | null;
        };
        readonly clientMutationId: string;
    };
};
export type PromoteMemberMutation = {
    readonly response: PromoteMemberMutationResponse;
    readonly variables: PromoteMemberMutationVariables;
};



/*
mutation PromoteMemberMutation(
  $input: PromoteMemberInput!
) {
  promoteMember(input: $input) {
    user {
      id
      role
      membershipScopes {
        sites {
          id
          name
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v2 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "PromoteModeratorPayload",
            "kind": "LinkedField",
            "name": "promoteMember",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMembershipScopes",
                            "kind": "LinkedField",
                            "name": "membershipScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Site",
                                    "kind": "LinkedField",
                                    "name": "sites",
                                    "plural": true,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PromoteMemberMutation",
            "selections": (v2 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PromoteMemberMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": "4e9057ff2bbac299d500cfdbd479a3a2",
            "metadata": {},
            "name": "PromoteMemberMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '56d5cf6310585760e95671a39b404f6d';
export default node;
